import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ApiBaseUrlContext } from '../App';
import './PersonnelManagement.css';
import '../table-list.css';
import '../table-list-2.css';
import { ReactComponent as FilterIcon } from '../assets/svg/icon-filter.svg';
import { ReactComponent as AddIcon } from '../assets/svg/icon-add.svg';
import { ReactComponent as RemoveItemIcon } from '../assets/svg/icon-remove-1.svg';
import { ReactComponent as HeaderIcon } from '../assets/svg/header-icon-machines.svg';
import { ReactComponent as ContextMenuIcon } from '../assets/svg/icon-more-options.svg';
import { ReactComponent as ToggleRowIcon } from '../assets/svg/icon-dropdown-arrow.svg';
import '../boxitem.css';
import '../topmenu.css';
import '../pageSearch.css';
import BoxItem from './BoxItem';
import bcrypt from 'bcryptjs';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import MachineDropdown from './MachineDropdown';
import GroupedDataTable from './GroupDataTable'; 
import GroupedDataTable2 from './GroupDataTable2'; 

const PersonnelManagement = () => {
  const { t } = useTranslation();
  const [personnel, setPersonnel] = useState([]);
  const [allMachines, setAllMachines] = useState([]); // New state for holding all machines
  const [newPersonnel, setNewPersonnel] = useState({
    username: '',
    userfirstname: '',
    userlastname: '',
    userexternal: true,
    usermobilenumber: '',
    userskills: '',
    company: '',
    companyaddress: '',
    companycontactperson: '',
    companycontactnumber: '',
    rateperhour: '',
    usernote: '',
    useremail: '',
    machineIDs: [], // Ensuring machineIDs is an array
    user_rights: 'Operator',
    receive_email: true,
  });
  const [search, setSearch] = useState('');
  const [showContent, setShowContent] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [editingAdmin, setEditingAdmin] = useState(false);
  const apiBaseUrl = useContext(ApiBaseUrlContext);
  const [editUserId, setEditUserId] = useState(null);
  const [openMenu, setOpenMenu] = useState(null);
  const navigate = useNavigate();
  const [openMenuId, setOpenMenuId] = useState(null);

  const groupPersonnelByRights = (personnelList) => {
    return personnelList.reduce((acc, person) => {
      const role = person.user_rights || "Unassigned";
      if (!acc[role]) {
        acc[role] = [];
      }
      acc[role].push(person);
      return acc;
    }, {});
  };

  const [groupedPersonnel, setGroupedPersonnel] = useState({});

  /*
  const toggleMenu = (event, userId) => {
    event.stopPropagation();
    setOpenMenu(openMenu === userId ? null : userId);
  };
  */

/*
  // Function to toggle menu
  const toggleMenu = (event, userId) => {
      event.stopPropagation(); // Prevent table row click from closing immediately
      setOpenMenuId(openMenuId === userId ? null : userId);
  };

  // Close menu when clicking outside
  useEffect(() => {
      const handleClickOutside = (event) => {
          if (!event.target.closest(".menu-container")) {
              setOpenMenuId(null);
          }
      };

      document.addEventListener("click", handleClickOutside);
      return () => document.removeEventListener("click", handleClickOutside);
  }, []);  
*/

  const confirmDelete = (userId) => {
    if (window.confirm(t('personnelManagement.confirmDelete'))) {
      handleDeletePersonnel(userId);
    }
    setOpenMenu(null);
  }

/*
  // Close menu if user clicks outside
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (!event.target.closest(".menu-container")) {
        setOpenMenu(null);
      }
    };

    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);
*/

  useEffect(() => {
    setGroupedPersonnel(groupPersonnelByRights(personnel));
  }, [personnel]);


  useEffect(() => {
    const fetchMachines = async () => {
      try {
        const response = await axios.get(`${apiBaseUrl}/mnt/api/machines/all`);
        setAllMachines(response.data);
      } catch (error) {
        console.error('Error fetching machines:', error);
      }
    };

    fetchTechnicians();
    fetchMachines();
  }, [apiBaseUrl]);

  const fetchTechnicians = async () => {
    try {
      const response = await axios.get(`${apiBaseUrl}/mnt/api/technicians/detailed`);
      setPersonnel(response.data);
      console.log(response.data);
    } catch (error) {
      console.error('Error fetching technicians:', error);
    }
  };

  const handleAddPersonnel = async () => {
    try {
      let hashedPassword = '';
      if (newPersonnel.password !== undefined && newPersonnel.password !== '') {
        hashedPassword = await bcrypt.hash(newPersonnel.password, 10);
      }
  
      const personnelData = {
        ...newPersonnel,
        password: hashedPassword || '',
        machineIDs: newPersonnel.machineIDs ? newPersonnel.machineIDs.join(',') : '',
        rateperhour: newPersonnel.rateperhour
          ? parseFloat(newPersonnel.rateperhour)
          : null,
        receive_email: newPersonnel.receive_email,
      };
  
      if (isEditing) {
        // Use the unique identifier stored in editUserId instead of an array index.
        const userid = editUserId;
  
        const updatedPersonnel = {
          ...personnelData,
          username: newPersonnel.username || '',
          userfirstname: newPersonnel.userfirstname || '',
          userlastname: newPersonnel.userlastname || '',
          usermobilenumber: newPersonnel.usermobilenumber || '',
          userskills: newPersonnel.userskills || '',
          company: newPersonnel.company || '',
          companyaddress: newPersonnel.companyaddress || '',
          companycontactperson: newPersonnel.companycontactperson || '',
          companycontactnumber: newPersonnel.companycontactnumber || '',
          rateperhour: newPersonnel.rateperhour
            ? parseFloat(newPersonnel.rateperhour)
            : null,
          usernote: newPersonnel.usernote || '',
          useremail: newPersonnel.useremail || '',
          machineIDs: newPersonnel.machineIDs
            ? newPersonnel.machineIDs.join(',')
            : '',
        };
        
  
        console.log('Updated personnel data (including machineIDs):', updatedPersonnel);
  
        await axios.put(`${apiBaseUrl}/mnt/api/technicians/${userid}`, updatedPersonnel);
  
        // Update the personnel array by replacing the record that matches the userid.
        const updatedPersonnelList = personnel.map((p) =>
          p.userid === userid ? { ...p, ...updatedPersonnel } : p
        );
        setPersonnel(updatedPersonnelList);
      } else {
        await axios.post(`${apiBaseUrl}/mnt/api/technicians`, {
          ...personnelData,
          username: newPersonnel.username || '',
          userfirstname: newPersonnel.userfirstname || '',
          userlastname: newPersonnel.userlastname || '',
          usermobilenumber: newPersonnel.usermobilenumber || '',
          userskills: newPersonnel.userskills || '',
          company: newPersonnel.company || '',
          companyaddress: newPersonnel.companyaddress || '',
          companycontactperson: newPersonnel.companycontactperson || '',
          companycontactnumber: newPersonnel.companycontactnumber || '',
          rateperhour: newPersonnel.rateperhour
            ? parseFloat(newPersonnel.rateperhour)
            : null,
          usernote: newPersonnel.usernote || '',
          useremail: newPersonnel.useremail || '',
        });
        setPersonnel([...personnel, newPersonnel]);
      }
  
      // Clear editing state and reset the form.
      setIsEditing(false);
      setEditUserId(null); // Clear the stored userid.
      setNewPersonnel({
        username: '',
        password: '',
        userfirstname: '',
        userlastname: '',
        userexternal: true,
        usermobilenumber: '',
        userskills: '',
        company: '',
        companyaddress: '',
        companycontactperson: '',
        companycontactnumber: '',
        rateperhour: '',
        usernote: '',
        useremail: '',
        machineIDs: [],
        user_rights: 'Operator',
        receive_email: true,
      });
      setShowForm(false);
      setShowContent(true);
      window.location.reload();
    } catch (error) {
      console.error(t('personnelManagement.errorSave'), error);
    }
  };
  

  const handleEditPersonnel = (userid) => {
    const selectedPersonnel = personnel.find(p => p.userid === userid);
    const machineIDs = selectedPersonnel.machineIDs
      ? selectedPersonnel.machineIDs.split(',').map(id => parseInt(id.trim(), 10))
      : [];

    setNewPersonnel({
      ...selectedPersonnel,
      machineIDs,
      user_rights: selectedPersonnel.user_rights || 'Operator',
      receive_email: selectedPersonnel.receive_email,
      password: '',
    });

    setIsEditing(true);
    setEditUserId(userid);
    setShowForm(true);
    setShowContent(false);

    // Scroll to top of the page smoothly
    window.scrollTo(0, 0);
  };
  
  // 🛑 Disable specific fields in the UI
  const isFieldDisabled = (field) => {
    return editUserId >= 2 && editUserId < 5000 && 
      ["username", "password", "userfirstname", "userlastname", "useremail"].includes(field);
  };
  

  const handleDeletePersonnel = async (userid) => {
    try {
      if (userid !== '1') {
        await axios.delete(`${apiBaseUrl}/mnt/api/technicians/${userid}`);
        await fetchTechnicians(); // Re-fetch to update the list after deletion
      }
    } catch (error) {
      console.error(t('personnelManagement.errorDelete'), error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewPersonnel({
      ...newPersonnel,
      [name]: value || '',
    });
  };

  const handleSelectAllMachines = () => {
    const allMachineIds = allMachines.map(machine => machine.machineid);
    setNewPersonnel({ ...newPersonnel, machineIDs: allMachineIds });
  };

  const handleDeselectAllMachines = () => {
    setNewPersonnel({ ...newPersonnel, machineIDs: [] });
  };

  const groupMachinesByCategory = () => {
    const grouped = {};
    allMachines.forEach(machine => {
      if (!grouped[machine.dncmaxgroupname]) {
        grouped[machine.dncmaxgroupname] = [];
      }
      grouped[machine.dncmaxgroupname].push(machine);
    });
    return grouped;
  };
  
  const handleSelectGroupMachines = (groupName) => {
    const groupedMachines = groupMachinesByCategory();
    const groupMachineIds = groupedMachines[groupName]?.map(machine => machine.machineid) || [];
    
    // Combine selected group machines with already selected ones, avoiding duplicates
    setNewPersonnel(prevState => ({
      ...prevState,
      machineIDs: [...new Set([...prevState.machineIDs, ...groupMachineIds])]
    }));
  };

  const handleDeselectGroupMachines = (groupName) => {
    const groupedMachines = groupMachinesByCategory();
    const groupMachineIds = groupedMachines[groupName]?.map(machine => machine.machineid) || [];
  
    // Remove only the machines from the selected group
    setNewPersonnel(prevState => ({
      ...prevState,
      machineIDs: prevState.machineIDs.filter(id => !groupMachineIds.includes(id))
    }));
  };


  useEffect(() => {
    const filtered = personnel.filter((p) =>
      p.username.toLowerCase().includes(search.toLowerCase()) ||
      p.userfirstname.toLowerCase().includes(search.toLowerCase()) ||
      p.userlastname.toLowerCase().includes(search.toLowerCase())
    );
  
    setGroupedPersonnel(groupPersonnelByRights(filtered));
  }, [personnel, search]);
  

  const handleRightsChange = (e) => {
    setNewPersonnel({
      ...newPersonnel,
      user_rights: e.target.value,
    });
  };


																	 

  return (

    <>

    {showForm && (

      <div className="modal-full">
      
        <div className="top-menu">
          <button type="button" className="button--blue" onClick={handleAddPersonnel}>{isEditing ? t('personnelManagement.updatePersonnel') : t('personnelManagement.addPersonnel')}</button>
          <div className="top-menu__button-space"></div>
            <button 
              type="button" 
              className="button--grey" 
              onClick={() => {
                setShowForm(false);
                setEditUserId(null); 
                setShowContent(true); // Ensure showContent is set to false
                setNewPersonnel({
                  username: '',
                  userfirstname: '',
                  userlastname: '',
                  userexternal: true,
                  usermobilenumber: '',
                  userskills: '',
                  company: '',
                  companyaddress: '',
                  companycontactperson: '',
                  companycontactnumber: '',
                  rateperhour: '',
                  usernote: '',
                  password:'',
                  useremail: '',
                  machineIDs: [],
                  user_rights: 'Operator',
                  receive_email: true,
                });
                setIsEditing(false);
              }}
            >{t('personnelManagement.cancel')}</button>
        </div>

        <div className="content__main-title">{isEditing ? t('personnelManagement.editPersonnel') : t('personnelManagement.addNewPersonnel')}</div>

        <div className="info-message" role="alert">
          {t('personnelManagement.internalUsers')}
        </div>

        <div className="form-section__title">
          Details
        </div>
        <div className="form-section">

         <div className="entry-item entry-item__small">
            <label htmlFor="user_rights" className="entry-label">{t('personnelManagement.userRights')}</label>
            <select
              id="user_rights"
              name="user_rights"
              className="entry-control"
              value={newPersonnel.user_rights || 'Operator'}
              onChange={handleRightsChange}
            >
              <option value="admin">Admin</option>
              <option value="operator">Operator</option>
              <option value="internal technician">Internal Technician</option>
              <option value="external technician">External Technician</option>
              <option value="display only">Display Only</option>
            </select>
          </div>

          <div className="entry-item entry-item__small">
            <label className="entry-label" htmlFor="username">{t('personnelManagement.username')}</label>
            <input
              type="text"
              id="username"
              name="username"
              className="entry-control"
              value={newPersonnel.username || ''}
              onChange={handleInputChange}
              disabled={isFieldDisabled("username")}
            />
          </div>

          <div className="entry-item entry-item__small">
            <label className="entry-label" htmlFor="password">{t('personnelManagement.password')}</label>
            <input
              type="password"
              id="password"
              name="password"
              className="entry-control"
              value={isFieldDisabled("password") ? t('personnelManagement.passwordRestricted') : newPersonnel.password || ''}
              onChange={handleInputChange}
              disabled={isFieldDisabled("password")}
            />
          </div>

          <div className="entry-item entry-item__small">
            <label htmlFor="userfirstname" className="entry-label">{t('personnelManagement.firstName')}</label>
            <input
              type="text"
              id="userfirstname"
              name="userfirstname"
              className="entry-control"
              value={newPersonnel.userfirstname || ''}
              onChange={handleInputChange}
              disabled={isFieldDisabled("userfirstname")}
            />
          </div>

          <div className="entry-item entry-item__small">
            <label htmlFor="userlastname" className="entry-label">{t('personnelManagement.lastName')}</label>
            <input
              type="text"
              id="userlastname"
              name="userlastname"
              className="entry-control"
              value={newPersonnel.userlastname || ''}
              onChange={handleInputChange}
              disabled={isFieldDisabled("userlastname")}
            />
          </div>

          <div className="entry-item entry-item__small">
            <label htmlFor="useremail" className="entry-label">{t('personnelManagement.email')}</label>
            <input
              type="email"
              id="useremail"
              name="useremail"
              className="entry-control"
              value={newPersonnel.useremail || ''}
              onChange={handleInputChange}
              disabled={isFieldDisabled("useremail")}
            />
          </div>

          <div className="entry-item entry-item__small">
            <label htmlFor="receive_email" className="entry-label">{t('personnelManagement.receiveEmail')}</label>
            <input
              type="checkbox"
              id="receive_email"
              name="receive_email"
              className="entry-control"
              checked={newPersonnel.receive_email}
              onChange={(e) =>
                setNewPersonnel({
                  ...newPersonnel,
                  receive_email: e.target.checked,
                })
              }
            />
          </div>

          <div className="entry-item entry-item__small">
            <label htmlFor="usermobilenumber" className="entry-label">{t('personnelManagement.mobileNumber')}</label>
            <input
              type="text"
              id="usermobilenumber"
              name="usermobilenumber"
              className="entry-control"
              value={newPersonnel.usermobilenumber || ''}
              onChange={handleInputChange}
            />
          </div>

          <div className="entry-item entry-item__medium">
            <label htmlFor="userskills" className="entry-label">{t('personnelManagement.skills')}</label>
            <input
              type="text"
              id="userskills"
              name="userskills"
              className="entry-control"
              value={newPersonnel.userskills || ''}
              onChange={handleInputChange}
            />
          </div>

          <div className="entry-item entry-item__medium">
            <label htmlFor="company" className="entry-label">{t('personnelManagement.company')}</label>
            <input
              type="text"
              id="company"
              name="company"
              className="entry-control"
              value={newPersonnel.company || ''}
              onChange={handleInputChange}
            />
          </div>

          <div className="entry-item entry-item__medium">
            <label htmlFor="companyaddress" className="entry-label">{t('personnelManagement.companyAddress')}</label>
            <input
              type="text"
              id="companyaddress"
              name="companyaddress"
              className="entry-control"
              value={newPersonnel.companyaddress || ''}
              onChange={handleInputChange}
            />
          </div>

          <div className="entry-item entry-item__small">
            <label htmlFor="companycontactperson" className="entry-label">{t('personnelManagement.companyContactPerson')}</label>
            <input
              type="text"
              id="companycontactperson"
              name="companycontactperson"
              className="entry-control"
              value={newPersonnel.companycontactperson || ''}
              onChange={handleInputChange}
            />
          </div>

          <div className="entry-item entry-item__small">
            <label htmlFor="companycontactnumber" className="entry-label">{t('personnelManagement.companyContactNumber')}</label>
            <input
              type="text"
              id="companycontactnumber"
              name="companycontactnumber"
              className="entry-control"
              value={newPersonnel.companycontactnumber || ''}
              onChange={handleInputChange}
            />
          </div>

          <div className="entry-item entry-item__8-digits">
            <label htmlFor="rateperhour" className="entry-label">{t('personnelManagement.ratePerHour')}</label>
            <input
              type="number"
              id="rateperhour"
              name="rateperhour"
              className="entry-control"
              value={newPersonnel.rateperhour || ''}
              onChange={handleInputChange}
              step="0.01"
            />
          </div>

         <div className="entry-item entry-item__full-width">
            <label htmlFor="usernote" className="entry-label">{t('personnelManagement.notes')}</label>
            <textarea
              id="usernote"
              name="usernote"
              className="entry-control"
              value={newPersonnel.usernote || ''}
              onChange={handleInputChange}
            />
          </div>

        </div>

        <div className="form-section__title">
          {t('personnelManagement.assignMachines')}
        </div>
        <div className="form-section">
          {/* Select/Deselect All */}
          <div className="entry-item__horizontal-buttons-top">
            <button onClick={handleSelectAllMachines} className="button--grey">
              {t('personnelManagement.selectAll')}
            </button>
            <div className="top-menu__button-space"></div>
            <button onClick={handleDeselectAllMachines} className="button--grey">
              {t('personnelManagement.deselectAll')}
            </button>
          </div>

          {/* Group Selection */}
          {Object.entries(groupMachinesByCategory()).map(([groupName, machines]) => (
            <div key={groupName} className="machine-group">
              <div className="machine-group__header">
                <span>{groupName}</span>
                <button onClick={() => handleSelectGroupMachines(groupName)} className="button--grey">
                  {t('personnelManagement.selectGroup')}
                </button>
                <button onClick={() => handleDeselectGroupMachines(groupName)} className="button--grey">
                  {t('personnelManagement.deselectGroup')}
                </button>
              </div>
              <ul>
                {machines.map(machine => (
                  <li key={machine.machineid}>
                    <input
                      type="checkbox"
                      checked={newPersonnel.machineIDs.includes(machine.machineid)}
                      onChange={() => {
                        const selected = newPersonnel.machineIDs.includes(machine.machineid)
                          ? newPersonnel.machineIDs.filter(id => id !== machine.machineid)
                          : [...newPersonnel.machineIDs, machine.machineid];
                        setNewPersonnel({ ...newPersonnel, machineIDs: selected });
                      }}
                    />
                    {machine.machine}
                  </li>
                ))}
              </ul>
            </div>
          ))}
          <div class="hidden">
            <MachineDropdown
              onSelectMachine={(selectedMachines) => setNewPersonnel({
                ...newPersonnel,
                machineIDs: selectedMachines,
              })}
              value={newPersonnel.machineIDs}
              multiSelect={true}
            />
          </div>
 
        </div>

        <div className="form-submit">
          <button type="button" className="button--blue" onClick={handleAddPersonnel}>{isEditing ? t('personnelManagement.updatePersonnel') : t('personnelManagement.addPersonnel')}</button>
          <div className="top-menu__button-space"></div>
          <button 
            type="button" 
            className="button--grey" 
            onClick={() => {
              setShowForm(false);
              setEditUserId(null); 
              setShowContent(true); // Ensure showContent is set to false
              setNewPersonnel({
                username: '',
                userfirstname: '',
                userlastname: '',
                userexternal: true,
                usermobilenumber: '',
                userskills: '',
                company: '',
                companyaddress: '',
                companycontactperson: '',
                companycontactnumber: '',
                rateperhour: '',
                usernote: '',
                password:'',
                useremail: '',
                machineIDs: [],
                user_rights: 'Operator',
                receive_email: true,
              });
              setIsEditing(false);

            }}
            >{t('personnelManagement.cancel')}</button>
        </div>
        
      </div>


    )}

    {showContent && (

      <div className="content">

        <div className="top-menu">
          <button type="button" className="button--icon-add button--green" 
            onClick={() => {
              setShowForm(true);
              setShowContent(false); // Ensure showContent is set to false
            }}>
            <AddIcon /> {t('personnelManagement.addNew')}
          </button>
        </div>

        {/* Header */}
        <div className="content__main-title">
            <div className="content__main-title-icon"><HeaderIcon /></div>
            {t('personnelManagement.title')}
        </div>

        <div className="search-section__field">
          <input 
            className="search-section__input"
            type="text"
            placeholder={t('personnelManagement.searchPlaceholder')}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <span 
            className="search-section__icon search-section__icon--clear"
            onClick={() => setSearch('')} // Clear the search field
          ><RemoveItemIcon /></span>
        </div>

<GroupedDataTable2
  groupedData={groupedPersonnel}
  headers={[
    {
      label: t("personnelManagement.username"),
      accessor: "username",
      elasticCell: true,
    },
    {
      label: t("personnelManagement.userRights"),
      accessor: "user_rights",
      hideMobile: true,
      colorStyle: "circle",
      colorValueFrom: (p) => p.user_rights,
    },
    {
      label: t("personnelManagement.name"),
      render: (p) => `${p.userfirstname} ${p.userlastname}`,
      hideMobile: true,
    },
    {
      label: t("personnelManagement.email"),
      accessor: "useremail",
      hideMobile: true,
    },
    {
      label: t("personnelManagement.mobileNumber"),
      accessor: "usermobilenumber",
      hideMobile: true,
    },
  ]}
  rowKeyFn={(p) => p.userid}
  getPrimaryActionLabel={() => t("personnelManagement.edit")}
  onPrimaryAction={(p) => handleEditPersonnel(p.userid)}
  contextualOptionsFn={(person) => [
    {
      label: t("personnelManagement.delete"),
      href: "#",
      onClick: (e) => {
        e.preventDefault();
        confirmDelete(person.userid);
      },
    },
  ]}
  groupMeta={{
    Administrator: {
      title: t("userRights.administrator"),
      description: t("personnelManagement.description.administrator"),
      emptyMessage: t("personnelManagement.empty.administrator"),
    },
    Supervisor: {
      title: t("userRights.supervisor"),
      description: t("personnelManagement.description.supervisor"),
      emptyMessage: t("personnelManagement.empty.supervisor"),
    },
    Operator: {
      title: t("userRights.operator"),
      description: t("personnelManagement.description.operator"),
      emptyMessage: t("personnelManagement.empty.operator"),
    },
  }}
/>



      </div>

    )}

    </>

  );
};

export default PersonnelManagement;
